import ReactOnRails from 'react-on-rails/client';
import Schedule from '../../app/Schedule.jsx';

ReactOnRails.register({Schedule});